import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { getCalenderEvents } from "../../actions/eventActions";
import { StoreContext } from "../../Context/StoreContext";
import Button from "../../VibehutUI/Button";
import EventCard from "../../VibehutUI/Card/EventCard";
import EventCardSkeleton from "../../VibehutUI/Skeletons/EventCardSkeleton";
import CalendarSkeletonLoader from "../../VibehutUI/Skeletons/CalenderSkeleton";

function HomeEventsCalender() {
  const { state, dispatch } = useContext(StoreContext);
  const {
    event: { calenderEvents, isRsvpUpdating, isFetching },
    auth: { user },
  } = state;
  const [markedDates, setmarkedDates] = useState([]);
  const [date, setDate] = useState(new Date());
  const [selectedEvents, setSelectedEvents] = useState([]);
  const eventsPerPage = 4;
  let arrayForHoldingEvents = [];
  const [eventsToShow, setEventsToShow] = useState([]);
  const [next, setNext] = useState(4);
  const [groupedData, setGroupedData] = useState();
  const [isLoader, setIsLoader] = useState(true);

  const [activeDates, setActiveDates] = useState([
    new Date(date.getFullYear(), date.getMonth(), 1).toString(),
  ]);

  useEffect(() => {
    if (calenderEvents.length === 0) {
      let next;
      var startDate = date;
      if (date.getMonth() === 11) {
        next = new Date(date.getFullYear() + 1, 0, 1);
      } else {
        next = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      }
      var endDate = new Date(next.getFullYear(), next.getMonth(), 0);
      getCalenderEvents(
        new Date(startDate.getFullYear(), startDate.getMonth(), 1),
        endDate,
        user?.token,
        dispatch,
        true
      );
    }

    const markedDate = calenderEvents.map((event) => {
      return moment(event.startDate).format("YYYY-MM-DD");
    });
    setmarkedDates(markedDate);
    const datewiseEvents = calenderEvents.filter((event) => {
      return (
        moment(event.startDate).format("YYYY-MM-DD") >=
          moment(date).format("YYYY-MM-DD") &&
        moment(event.startDate).format("YYYY-MM-DD") <=
          moment(date).add(1, "month").format("YYYY-MM-DD")
      );
    });

    const sortedEvents = datewiseEvents.sort((a, b) => {
      return new Date(a.startDate) - new Date(b.startDate);
    });

    setSelectedEvents(sortedEvents);
    loopWithSlice(0, eventsPerPage, sortedEvents);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calenderEvents, isRsvpUpdating]);

  const handleDateChage = (value) => {
    setDate(value);
    const datewiseEvents = calenderEvents.filter((event) => {
      return (
        moment(event.startDate).format("YYYY-MM-DD") >=
          moment(value).format("YYYY-MM-DD") &&
        moment(event.startDate).format("YYYY-MM-DD") <=
          moment(value).add(1, "month").format("YYYY-MM-DD")
      );
    });

    //sort by startdate month
    const sortedEvents = datewiseEvents.sort((a, b) => {
      const startDateMonthA = moment(a.startDate).format("MM");
      const startDateMonthB = moment(b.startDate).format("MM");

      if (startDateMonthA < startDateMonthB) {
        return -1;
      }
      if (startDateMonthA > startDateMonthB) {
        return 1;
      }
      return 0;
    });

    const sortedEventsByStartTime = sortedEvents.sort((a, b) => {
      if (
        moment(a.startDate).format("YYYY-MM-DD") ===
        moment(b.startDate).format("YYYY-MM-DD")
      ) {
        return -1;
      }
    });

    setSelectedEvents(sortedEventsByStartTime);
    setEventsToShow([]);
    loopWithSlice(0, eventsPerPage, sortedEventsByStartTime);
  };

  const loopWithSlice = (start, end, events) => {
    const slicedEvents = events.slice(start, end);
    if (start === 0) {
      arrayForHoldingEvents = [...slicedEvents];
    } else {
      arrayForHoldingEvents = [...eventsToShow, ...slicedEvents];
    }
    setEventsToShow(arrayForHoldingEvents);
    if (arrayForHoldingEvents.length === events.length || events.length <= 4) {
      setIsLoader(false);
    } else {
      setIsLoader(true);
    }
    const grouping = groupByDate(arrayForHoldingEvents);
    var result = Object.keys(grouping).map((key) => [key, grouping[key]]);
    result = result.map((item) => {
      const sorted = item[1].sort((a, b) => {
        return new Date(a.startDate) - new Date(b.startDate);
      });
      return [item[0], sorted];
    });
    setGroupedData([...result]);
  };

  const handleShowMoreEvents = () => {
    loopWithSlice(next, next + eventsPerPage, selectedEvents);
    setNext(next + eventsPerPage);
  };

  const groupByDate = (events) => {
    return events.reduce((acc, event) => {
      const date = moment(event.startDate).format("YYYY-MM-DD");
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(event);
      return acc;
    }, {});
  };

  return (
    <div className="flex flex-col  space-x-0 space-y-6 md:space-y-0 pb-8">
      <div className="block  w-full pt-8">
        <p className="select-none font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite px-2">
          Calendar
        </p>
      </div>
      <div className="flex md:flex-row flex-col gap-4">
        <div className="md:pt-6 px-2 md:w-1/2 w-full">
          {isFetching ? (
            <CalendarSkeletonLoader />
          ) : (
            <Calendar
              onChange={handleDateChage}
              value={date}
              tileClassName={({ date }) => {
                if (
                  markedDates.find(
                    (x) => x === moment(date).format("YYYY-MM-DD")
                  )
                ) {
                  return "highlight";
                } else {
                  return "nonhighlight";
                }
              }}
              className=""
              onActiveStartDateChange={({
                action,
                activeStartDate,
                value,
                view,
              }) => {
                if (view === "month" && action === "next") {
                  let next;
                  var date1 = new Date(activeStartDate);
                  var startDate1 = new Date(
                    date1.getFullYear(),
                    date1.getMonth(),
                    1
                  );
                  if (startDate1.getMonth() === 11) {
                    next = new Date(startDate1.getFullYear() + 1, 0, 1);
                  } else {
                    next = new Date(
                      startDate1.getFullYear(),
                      startDate1.getMonth() + 1,
                      1
                    );
                  }
                  var endDate1 = new Date(
                    next.getFullYear(),
                    next.getMonth(),
                    0
                  );
                  if (!activeDates.includes(activeStartDate.toString())) {
                    getCalenderEvents(
                      startDate1,
                      endDate1,
                      user?.token,
                      dispatch,
                      false
                    );
                    setActiveDates([
                      ...activeDates,
                      activeStartDate.toString(),
                    ]);
                  }
                }
                if (view === "month" && action === "prev") {
                  let prev;
                  var date2 = new Date(activeStartDate);

                  var startDate2 = new Date(
                    date2.getFullYear(),
                    date2.getMonth() - 1,
                    1
                  );
                  if (startDate2.getMonth() === 0) {
                    prev = new Date(startDate2.getFullYear() - 1, 11, 1);
                  } else {
                    prev = startDate2;
                  }

                  var endDate2 = new Date(
                    prev.getFullYear(),
                    prev.getMonth() + 1,
                    0
                  );
                  if (!activeDates.includes(activeStartDate.toString())) {
                    getCalenderEvents(
                      startDate2,
                      endDate2,
                      user?.token,
                      dispatch,
                      false
                    );
                    setActiveDates([
                      ...activeDates,
                      activeStartDate.toString(),
                    ]);
                  }
                }
              }}
            />
          )}
        </div>
        {!isFetching ? (
          <div className="md:w-1/2 w-full px-2">
            {groupedData &&
              groupedData.map((item) => (
                <div className="flex flex-col md:pt-4  pb-4">
                  <p className="text-lg text-darkNight dark:text-frescoWhite px-2 font-bold">
                    {moment(item[0]).format("MMMM DD, YYYY")}
                  </p>
                  {item[1].map((event) => (
                    <EventCard
                      event={event}
                      showRoomLink
                      isHomeEvent
                      isEnded={moment(event.endDate) < moment.now()}
                    />
                  ))}
                </div>
              ))}
            <div className="flex justify-center py-2">
              {isLoader && (
                <Button
                  size="vibhut-sm"
                  variant="vibhut-secondary"
                  onClick={handleShowMoreEvents}
                >
                  Load More
                </Button>
              )}
            </div>
          </div>
        ) : (
          <div className="md:w-1/2 w-full px-2">
            <EventCardSkeleton numberOfCards={3} />
          </div>
        )}
      </div>
    </div>
  );
}

export default HomeEventsCalender;
